package com.example.mystybag.core.logic.helpers

import com.arkivanov.decompose.router.slot.ChildSlot
import com.arkivanov.decompose.value.Value
import com.example.mystybag.core.logic.base.BottomSheetChild
import com.example.mystybag.core.logic.base.UIBottomSheetConfig
import com.example.mystybag.core.model.BaseUIState

interface UIBottomSheetControl {
    val baseUIState : Value<BaseUIState>
    val sheetState  : Value<ChildSlot<UIBottomSheetConfig, BottomSheetChild>>
    fun closeBottomSheet(action: ((BottomSheetChild?) -> Unit)? = null)
    fun bottomSheetDidClose(child: BottomSheetChild? = null)
}